import BaseService from './base.service';

export default class AmbraNamespaceService extends BaseService {
  getAmbraNamespace(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/ambra-namespace/all${queryString}`);
  }
}
